__turbopack_context__.v({
  "company": "company-module-scss-module__w9HlEa__company",
});
